import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaBars } from 'react-icons/fa';
import { FiPhone, FiSend } from 'react-icons/fi';
import { MdShoppingCart } from 'react-icons/md';
import { AiOutlineUser } from 'react-icons/ai';
import { apiClient } from '../config/apiConfig';

interface OrderItem {
  productName: string;
  productImage: string;
  quantity: number;
  priceAtPurchase: number;
  variantPriceAtPurchase?: number;
}

interface Order {
  orderId: number;
  status: string;
  orderDate: string;
  totalAmount: number;
  orderItems: OrderItem[];
}
interface CartItem {
  cartItemsId: number;
  productId: number;
  variantId: number | null;
  productName: string;
  variantDescription: string | null;
  priceAtPurchase: number;
  variantPrice?: number;
  quantity: number;
  productImage: string;
}

const MyOrders: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [customerName, setCustomerName] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  // ✅ get customerId from localStorage
  const customerId = localStorage.getItem("customerId");

  useEffect(() => {
    const name = localStorage.getItem("customerName");
    if (name && name.trim() !== "" && name !== "undefined") {
      setCustomerName(name);
    } else {
      setCustomerName(null);
    }
  }, []);

  // Helper function to get the effective price (variant price if available, otherwise product price)
  const getItemPrice = (item: OrderItem | CartItem): number => {
    if ('variantPriceAtPurchase' in item && item.variantPriceAtPurchase) {
      return item.variantPriceAtPurchase;
    }
    if ('variantPrice' in item && item.variantPrice) {
      return item.variantPrice;
    }
    return item.priceAtPurchase;
  };

  useEffect(() => {
    if (!customerId) return; // not logged in

    apiClient
      .get(`/Orders/GetOrders/${customerId}`)
      .then((response) => {
        console.log("Orders:", response.data);

        const sortedOrders = response.data.sort(
          (a: Order, b: Order) =>
            new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime()
        );

        setOrders(sortedOrders);
      })
      .catch((error) => {
        console.error("Error fetching orders", error);
      });
  }, [customerId]);

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const customerId = localStorage.getItem("customerId");
        if (!customerId) {
          console.error("No customerId found in localStorage");
          return;
        }

        const response = await apiClient.get(
          `/Cart/GetCartByCustomerId?customerId=${customerId}`
        );

        console.log("Cart data:", response.data);

        // ✅ directly set items (API already shaped as items[])
        setCartItems(response.data.items || []);

      } catch (error) {
        console.error("Error fetching cart items:", error);
      } finally {
        setLoading(false); // ✅ stop loading spinner
      }
    };

    fetchCart();
  }, []);

  const handleIncrease = async (item: CartItem) => {
    try {
      const updatedCart = cartItems.map((i) =>
        i.cartItemsId === item.cartItemsId
          ? { ...i, quantity: i.quantity + 1 }
          : i
      );
      setCartItems(updatedCart);

      // Optional: update quantity in backend
      await apiClient.put(`/Cart/UpdateQuantity`, {
        cartItemsId: item.cartItemsId,
        quantity: item.quantity + 1,
      });
    } catch (error) {
      console.error("Error increasing quantity:", error);
    }
  };

  const handleDecrease = async (item: CartItem) => {
    if (item.quantity <= 1) return; // prevent 0 quantity
    try {
      const updatedCart = cartItems.map((i) =>
        i.cartItemsId === item.cartItemsId
          ? { ...i, quantity: i.quantity - 1 }
          : i
      );
      setCartItems(updatedCart);

      // Optional: update quantity in backend
      await apiClient.put(`/Cart/UpdateQuantity`, {
        cartItemsId: item.cartItemsId,
        quantity: item.quantity - 1,
      });
    } catch (error) {
      console.error("Error decreasing quantity:", error);
    }
  };
  const totalCount = cartItems.length;

  return (
    <>
      {/* ✅ Top Info Bar */}
      <div className="py-1 bg-primary" style={{ zIndex: 3, position: 'relative' }}>
        <div className="py-1 bg-primary w-100">
          <div className="container">
            <div className="row d-flex align-items-center text-white">
              <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
                <FiPhone size={14} className="mr-2" />
                <span>+91 9148761750</span>
              </div>

              <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
                <FiSend size={14} className="mr-2" />
                <span>care@fhome.shop</span>
              </div>

              <div className="col-12 col-md text-md-right">
                <span>3-5 Business days delivery & Free Returns</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* ✅ Navbar */}
      <nav
        className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light"
        id="ftco-navbar"
        style={{ zIndex: 2 }}
      >
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt="Logo"
              style={{ height: '55px', marginRight: '8px', borderRadius: '50%', width: '80px' }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#ftco-nav"
            aria-controls="ftco-nav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <FaBars className="mr-2" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a href="/" className="nav-link">
                  Home
                </a>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="dropdown04"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Shop
                </a>
                <div className="dropdown-menu" aria-labelledby="dropdown04">
                  <a className="dropdown-item" href="/shop">
                    Shop
                  </a>
                </div>
              </li>
              <li className="nav-item active">
                <a href="/about" className="nav-link">
                  About
                </a>
              </li>
              {/* <li className="nav-item">
                <a href="/blog" className="nav-link">
                  Blog
                </a>
              </li> */}
              <li className="nav-item">
                <a href="/contact" className="nav-link">
                  Contact
                </a>
              </li>
              <li className="nav-item cta cta-colored"> <a href="/cart" className="nav-link">
                <span><MdShoppingCart size={18} /></span> [{totalCount}]
              </a></li>
              <li className="nav-item">
                <a
                  href="/my-account"
                  className="nav-link d-flex align-items-center"
                  style={{ gap: "6px" }}
                >
                  <AiOutlineUser size={24} style={{ color: "#898989" }} />

                  {customerName ? (
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#999",
                        maxWidth: "120px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                      title={`Hi, ${customerName}`}
                    >
                      Hi, {customerName}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#999"
                      }}
                    >
                      Login
                    </span>
                  )}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ✅ My Orders Section */}
      <div className="container py-5">
        <h2>My Orders</h2>
        {orders.length === 0 ? (
          <p>No orders found.</p>
        ) : (
          <div className="row">
            {orders.map((order) => (
              <div key={order.orderId} className="col-md-12 mb-4">
                <div className="card shadow">
                  <div className="card-header">
                    <strong>Order #{order.orderId}</strong> |{' '}
                    {new Date(order.orderDate).toLocaleDateString()} | Total: ₹{order.totalAmount.toFixed(2)}
                  </div>
                  <div className="card-body">
                    {order.orderItems.map((item, index) => (
                      <div key={index} className="d-flex align-items-center mb-3">
                        <img
                          src={item.productImage ? `https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net${item.productImage}` : "/images/placeholder.png"}
                          alt={item.productName}
                          style={{ width: 60, height: 60, objectFit: "contain" }}
                        />

                        <div className="ms-3">
                          <h6>{item.productName}</h6>
                          <p>
                            Qty: {item.quantity} | Price: ₹{getItemPrice(item).toFixed(2)}
                          </p>
                        </div>
                      </div>
                    ))}
                    <p>
                      Status: <strong>{order.status}</strong>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default MyOrders;

